module.exports = __webpack_public_path__ + "img/hand.a2b4076b.svg";